import { render, staticRenderFns } from "./template03.vue?vue&type=template&id=8809072c&scoped=true&"
import script from "./template03.vue?vue&type=script&lang=js&"
export * from "./template03.vue?vue&type=script&lang=js&"
import style0 from "./template03.vue?vue&type=style&index=0&id=8809072c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8809072c",
  null
  
)

export default component.exports